import Swiper from 'swiper/dist/js/swiper.min';
import Vue from 'vue';
import PopupFullscreen from '../../popup/fullscreen/popup-fullscreen';
import AnimationFade from '../../../core/animation/fade/animation-fade';

export default function () {
  const facing = document.querySelectorAll('.facing-section-horizontal');

  if (facing && facing.length) {
    [].slice.call(facing).forEach((elem) => {
      const objectName = elem.getAttribute('data-object');
      const object = window[`${objectName}`];
      window.VueEvent = new Vue();
      new Vue({
        el: elem,
        delimiters: ['${', '}}'],
        components: {
          AnimationFade,
          PopupFullscreen,
        },
        data() {
          return {
            facingSection: object,
            newTitle: '',
            isMobile: window.innerWidth < 1280,
            mainSlider: null,
            thumbSlider: null,
            thumb: null,
            main: null,
            optionsMain: null,
            optionsThumb: null,
            activeTabs: null,
            popupFullOpen: false,
            tabs: null,
            facing: null,
            tabArrows: [],
            sliders: [],
            fullscreenCards: [],
            fullscreenActive: 0,
            description: '',
            currentIndex: 0,
            activeTabButton: null,
          };
        },
        mounted() {
          this.firstButtonInited = true;
          if (this.facingSection.title) {
            this.newTitle = this.facingSection.title.normal ? this.facingSection.title.normal + (this.facingSection.title.cursive ? this.facingSection.title.cursive : '') : '';
          }
          this.tabs = this.$refs.tabs;
          this.facing = this.$refs.facing;

          window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 1280;
          });

          if (this.facing) {
            this.tabArrows = [].slice.call(this.facing.querySelectorAll('.facing-section-horizontal__tabs-button'));
            this.tabBtns = [].slice.call(this.facing.querySelectorAll('.facing-section-horizontal__tab-btn'));
            this.sliders = [].slice.call(this.facing.querySelectorAll('.facing-section-horizontal__tab'));
            if (!this.facingSection.isAside && this.$refs.inlineTabs) {
              this.$refs.inlineTabs.classList.add('facing-section-horizontal__tabs--top');
            }
          }
          const left = this.tabArrows.find(el => el.dataset.arrow === 'left');
          const right = this.tabArrows.find(el => el.dataset.arrow === 'right');

          if (left && right) {
            this.toggleViewArrow(left, right);
          }

          if (this.tabs) {
            Array.from(this.tabs.children).forEach((tab, index) => {
              if (tab.classList.contains('facing-section-horizontal__tab-btn--active')) {
                if (index === 0) {
                  this.tabs.scrollTop = 0;
                  this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--top');
                }
                if (index === Array.from(this.tabs.children).length - 1) {
                  this.tabs.scrollTop = this.tabs.scrollHeight - this.tabs.offsetHeight;
                  this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--bottom');
                }
                this.description = this.facingSection.tabs.btns[index].description;
                this.slidersInit(this.sliders[index], index);
              }
            });
            this.tabs.addEventListener('scroll', (e) => {
              const newHeight = e.target.scrollHeight - e.target.offsetHeight;
              const newWidth = e.target.scrollWidth - e.target.offsetWidth;
              if (this.facingSection.isAside) {
                if (e.target.scrollLeft === 0) {
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--bottom');
                  e.target.parentElement.classList.add('facing-section-horizontal__tabs--top');
                } else if (e.target.scrollLeft === newWidth) {
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--top');
                  e.target.parentElement.classList.add('facing-section-horizontal__tabs--bottom');
                } else {
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--top');
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--bottom');
                }
              } else if (!this.facingSection.isAside) {
                if (e.target.scrollLeft === 0 && this.isMobile) {
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--bottom');
                  e.target.parentElement.classList.add('facing-section-horizontal__tabs--top');
                } else if (e.target.scrollTop === 0 && !this.isMobile) {
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--bottom');
                  e.target.parentElement.classList.add('facing-section-horizontal__tabs--top');
                } else if (e.target.scrollLeft === newWidth && this.isMobile) {
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--top');
                  e.target.parentElement.classList.add('facing-section-horizontal__tabs--bottom');
                } else if ((e.target.scrollTop === (newHeight - 1)) && !this.isMobile) {
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--top');
                  e.target.parentElement.classList.add('facing-section-horizontal__tabs--bottom');
                } else {
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--top');
                  e.target.parentElement.classList.remove('facing-section-horizontal__tabs--bottom');
                }
              }
            });
          }

          if (this.facingSection.isAside && this.tabs.scrollWidth === this.tabs.offsetWidth) {
            this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--bottom');
          }

          window.addEventListener('resize', () => {
            const prevBtn = this.tabArrows.filter(itemBtn => itemBtn.dataset.arrow === 'left')[0];
            const nextBtn = this.tabArrows.filter(itemBtn => itemBtn.dataset.arrow === 'right')[0];
            const maxScrollLeft = this.tabs.scrollWidth - this.tabs.offsetWidth;
            if (!prevBtn) return;
            if (!nextBtn) return;
            if (this.tabs.scrollLeft === 0) {
              this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--top');
            } else {
              this.tabs.parentElement.classList.remove('facing-section-horizontal__tabs--top');
            }
            if (this.tabs.scrollLeft === maxScrollLeft) {
              this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--bottom');
            } else {
              this.tabs.parentElement.classList.remove('facing-section-horizontal__tabs--bottom');
            }
          });

          if (this.tabArrows.length !== 0) {
            this.tabArrows.forEach((btn) => {
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                const maxScrollLeft = this.tabs.scrollWidth - this.tabs.offsetWidth;
                if (btn.dataset.arrow === 'up') {
                  this.tabs.scrollTop = 0;
                  this.tabs.parentElement.classList.remove('facing-section-horizontal__tabs--bottom');
                  this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--top');
                } else if (btn.dataset.arrow === 'left') {
                  if (this.tabs.scrollLeft - 100 > 0) {
                    this.tabs.scrollLeft = this.tabs.scrollLeft - 100;
                  } else {
                    this.tabs.scrollLeft = 0;
                    this.tabs.parentElement.classList.remove('facing-section-horizontal__tabs--bottom');
                    this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--top');
                  }
                  if (this.currentIndex !== 0 && this.tabBtns.length && this.activeTabButton) {
                    this.changeTabByArrow(this.activeTabButton, this.currentIndex, false);
                  }
                  if (left && right) {
                    this.toggleViewArrow(left, right);
                    if (this.tabBtns && this.tabBtns.length && this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section-horizontal__tab-btn--active')) {
                      this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--bottom');
                    }
                  }
                } else if (btn.dataset.arrow === 'right') {
                  if (maxScrollLeft > this.tabs.scrollLeft + 100) {
                    this.tabs.scrollLeft = this.tabs.scrollLeft + 100;
                  } else {
                    this.tabs.scrollLeft = maxScrollLeft;
                  }
                  this.changeTabByArrow(this.activeTabButton, null, true);
                  if (left && right) {
                    this.toggleViewArrow(left, right);
                  }
                  if (this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section-horizontal__tab-btn--active')) {
                    const prnt = this.tabs.parentElement;
                    prnt.classList.add('facing-section-horizontal__tabs--hide');
                  } else {
                    this.tabs.parentElement.classList.remove('facing-section-horizontal__tabs--hide');
                  }
                } else {
                  this.tabs.scrollTop = this.tabs.offsetHeight;
                  this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--bottom');
                  this.tabs.parentElement.classList.remove('facing-section-horizontal__tabs--top');
                }
                if (this.tabBtns[0].classList.contains('facing-section-horizontal__tab-btn--active')) {
                  this.tabs.scrollLeft = 0;
                }
                if (this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section-horizontal__tab-btn--active')) {
                  this.tabs.scrollLeft = this.tabs.scrollWidth - this.tabs.offsetWidth;
                }
              });
            });
          }
          if (this.tabBtns.length !== 0) {
            this.tabBtns.forEach((btn, index) => {
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.currentIndex = index;
                this.activeTabButton = this.tabBtns[this.currentIndex];
                if (left && right) {
                  this.toggleViewArrow(left, right);
                }
                this.changeTabs(btn, index);
                if (this.tabBtns && this.tabBtns.length) {
                  if (this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section-horizontal__tab-btn--active')) {
                    this.tabs.parentElement.classList.add('facing-section-horizontal__tabs--bottom');
                  }
                }
                if (this.tabBtns[0].classList.contains('facing-section-horizontal__tab-btn--active')) {
                  this.tabs.scrollLeft = 0;
                }
                if (this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section-horizontal__tab-btn--active')) {
                  this.tabs.scrollLeft = this.tabs.scrollWidth - this.tabs.offsetWidth;
                }
              });
            });
          }
          if (this.tabBtns.length) {
            this.activeTabButton = this.tabBtns.find(el => el.classList.contains('facing-section-horizontal__tab-btn--active'));
          }
        },
        methods: {
          changeTabs(btn, index) {
            this.tabBtns.forEach(tmp => tmp.classList.remove('facing-section-horizontal__tab-btn--active'));
            this.sliders.forEach(tmp => tmp.classList.remove('facing-section-horizontal__tab--active'));
            this.sliders[index].classList.add('facing-section-horizontal__tab--active');
            this.description = this.facingSection.tabs.btns[index].description;
            btn.classList.add('facing-section-horizontal__tab-btn--active');
            this.slidersInit(this.sliders[index], index);
          },

          slidersInit(tab, num) {
            const mainSlider = tab.querySelector('.facing-section-horizontal__main-slider');
            let sliderCounter = tab.querySelector('.sliderButtons__counter');

            this.fullscreenCards = [];

            this.facingSection.tabs.elements[num].slider.forEach((slide) => {
              this.fullscreenCards.push(slide);
            });

            const slideCount = this.facingSection.tabs.elements[num].slider.length;

            const options = {
              slidesPerView: slideCount < 4 ? slideCount : 4,
              spaceBetween: 8,
              breakpoints: {
                1280: {
                  slidesPerView: slideCount < 1 ? slideCount : 1,
                },
                1919: {
                  slidesPerView: slideCount < 3 ? slideCount : 3,
                },
              },
              loop: false,
              navigation: {
                nextEl: this.$el.querySelector('.sliderButtons__btn--next'),
                prevEl: this.$el.querySelector('.sliderButtons__btn--prev'),
                disabledClass: 'a',
              },
              observer: true,
              observeParents: true,
              on: {
                init() {
                  sliderCounter = this.el.querySelector('.sliderButtons__counter');
                  if (sliderCounter) {
                    sliderCounter.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
                    sliderCounter.querySelector('[data-name=slidesLength]').textContent = this.slides.length - 2;
                  }
                  const wrapper = this.el.closest('.facing-section-horizontal__wrapper');
                  const btns = wrapper ? wrapper.querySelector('.facing-section-horizontal__slider-btns') : null;
                  if (this.slides.length <= 1) {
                    if (btns) {
                      // btns.style.display = 'none';
                    }
                    if (this.el.querySelector('.facing-section-horizontal__slider-btns')) {
                      // this.el.querySelector('.facing-section-horizontal__slider-btns').style.display = 'none';
                      if (this.el.nextElementSibling) {
                        // this.el.nextElementSibling.style.display = 'none';
                      }
                    }
                  } else {
                    if (btns) {
                      // btns.style.display = 'flex';
                    }
                    if (this.el.nextElementSibling) {
                      // this.el.nextElementSibling.style.display = 'block';
                    }
                  }
                },
                slideChange() {
                  sliderCounter = this.el.querySelector('.sliderButtons__counter');
                  if (sliderCounter) {
                    sliderCounter.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
                  }
                },
              },
            };

            if (mainSlider.querySelectorAll('.swiper-slide').length === 1) {
              options.loop = false;
            }

            if (!tab.initedSwiper) {
              tab.initedSwiper = true;
              new Swiper(mainSlider, options);
              if (this.firstButtonInited) {
                this.firstButtonInited = false;
                this.nextSliderButton = this.$el.querySelector('.sliderButtons__btn--next');
                this.prevSliderButton = this.$el.querySelector('.sliderButtons__btn--prev');

                if (this.nextSliderButton && this.prevSliderButton) {
                  let isLast = this.nextSliderButton.getAttribute('aria-disabled') === 'true';
                  let isFirst = this.prevSliderButton.getAttribute('aria-disabled') === 'true';

                  this.nextSliderButton.addEventListener('click', () => {
                    if (isLast) {
                      this.changeTabByArrow(this.activeTabButton, this.currentIndex, true);
                    }
                    isLast = this.nextSliderButton.getAttribute('aria-disabled') === 'true';
                    isFirst = this.prevSliderButton.getAttribute('aria-disabled') === 'true';
                  });
                  this.prevSliderButton.addEventListener('click', () => {
                    if (isFirst) {
                      this.changeTabByArrow(this.activeTabButton, this.currentIndex, false);
                    }
                    isFirst = this.prevSliderButton.getAttribute('aria-disabled') === 'true';
                    isLast = this.nextSliderButton.getAttribute('aria-disabled') === 'true';
                  });
                }
              }
            }
          },

          openFullPopup() {
            const popup = this.$el.querySelector('.popup-fullscreen');
            window.bodyLock.disableBodyScroll(popup);
            setTimeout(() => {
              this.popupFullOpen = true;
            }, 500);
          },
          changeTabByArrow(btn, index, next) {
            if (next) {
              if ((this.currentIndex + 1) === this.tabBtns.length) {
                this.currentIndex = 0;
              } else {
                this.currentIndex += 1;
              }
            } else if (!next) {
              if (this.currentIndex === 0) {
                this.currentIndex = this.tabBtns.length - 1;
              } else {
                this.currentIndex -= 1;
              }
            }
            this.activeTabButton = this.tabBtns[this.currentIndex];
            this.changeTabs(this.activeTabButton, this.currentIndex);
          },
          toggleViewArrow(left, right) {
            if (this.tabBtns.length) {
              left.style.visibility = (this.currentIndex === 0) ? 'hidden' : 'visible';
              right.style.visibility = (this.currentIndex === (this.tabBtns.length - 1)) ? 'hidden' : 'visible';
            }
          },
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./blocks/facing-section/horizontal/facing-section-horizontal.js